<template>
  <div class="modal" :style="{ display: showmodal }">
    <div class="modal-background"></div>
    <div class="modal-card" style="margin-top:200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <p>{{ text }}</p>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-danger" @click="ok">OK</button>
        <button class="button" @click="dismiss">Annuler</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showmodal() {
      return this.show ? 'block' : 'none'
    }
  },
  methods: {
    ok() {
      this.$emit('modalconfirm')
    },
    dismiss() {
      this.$emit('modaldissmiss')
    }
  }
}
</script>

<style scoped>
.modal {
  /*display:block;*/
}
</style>